import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import CommonButton from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import AddProjectModal from '../add-project-modal/AddProjectModal';
import { resetAccessProjects } from '../../../../redux/customers/customersReducer';

import scss from './AddProjectButton.module.scss';

function AddProjectButton() {
  const { t } = useTranslation('customers');
  const dispatch = useDispatch();

  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);

  const handleOpenAddProjectModal = () => {
    setIsAddProjectModalOpen(true);
  };

  const handleCloseAddProjectModal = () => {
    setIsAddProjectModalOpen(false);
    dispatch(resetAccessProjects());
  };

  return (
    <div className={scss.wrapper}>
      <CommonButton styleColor='secondary' className={scss.button} maxWidth={140} onClick={handleOpenAddProjectModal}>
        <Icon icon={ICONS.CirclePlus} />
        {t('addProject')}
      </CommonButton>

      <AddProjectModal isOpen={isAddProjectModalOpen} onClose={handleCloseAddProjectModal} />
    </div>
  );
}

export default AddProjectButton;
